import { render, staticRenderFns } from "./contactExample.vue?vue&type=template&id=60d4e5b1&scoped=true&"
import script from "./contactExample.vue?vue&type=script&lang=ts&"
export * from "./contactExample.vue?vue&type=script&lang=ts&"
import style0 from "./contactExample.vue?vue&type=style&index=0&id=60d4e5b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4e5b1",
  null
  
)

export default component.exports